const API_BASE_URL: string = (import.meta.env.VITE_API_URL || "").replace(/\/$/, "");

function withBase(path: string): string {
  return `${API_BASE_URL}${path}`;
}

export async function checkCustomerSession(): Promise<boolean> {
  try {
    const headers: Record<string, string> = {};
    // Attach token if present (for local dev)
    try {
      const token = sessionStorage.getItem("recruit_ai_token");
      if (token) headers["Authorization"] = `Bearer ${token}`;
    } catch {}

    const resp = await fetch(withBase("/customer/info"), {
      method: "GET",
      headers: Object.keys(headers).length ? headers : undefined,
      credentials: "include",
    });
    return resp.ok;
  } catch {
    return false;
  }
}

export async function checkAdminSession(): Promise<boolean> {
  try {
    const headers: Record<string, string> = {};
    // Attach token if present (for local dev)
    try {
      const token = sessionStorage.getItem("recruit_ai_token");
      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      } else {
        // No token in sessionStorage, can't be admin
        return false;
      }
    } catch {}

    const url = withBase("/admin/customers");
    const resp = await fetch(url, {
      method: "GET",
      headers: Object.keys(headers).length ? headers : undefined,
      credentials: "include",
    });
    return resp.ok;
  } catch {
    return false;
  }
}
